import axios from "axios";

function getBaseUrl() {
  return PubHub.env == 'production' ? "https://devnet.cisco.com/v1/raffles" : "https://devnet-testing.cisco.com/v1/raffles";
}

export function fetchRaffle(id) {
  const baseUrl = getBaseUrl();
  return axios({
    method: "get",
    url: `${baseUrl}/${id}/public`
  });
}

export function createAttendee(id, answers) {
  const baseUrl = getBaseUrl();
  return axios({
    method: "post",
    url: `${baseUrl}/${id}/attendees`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      weight: 1,
      answers: answers
    },
    withCredentials: true
  });
}

export function fetchAttendees(id) {
  const baseUrl = getBaseUrl();
  return axios({
    method: "get",
    url: `${baseUrl}/${id}/attendees/public`
  });
}
